import { useState } from 'react';
import { Link } from 'react-router-dom';
import { ChevronDown, MessageCircle, ArrowRight } from 'lucide-react';
import { Button } from '@/components/ui/button';
import helpContent from '@/data/help.json';

const faq = helpContent.ambientes.publica.telas.faq;

export const PublicFaq = () => {
  const [open, setOpen] = useState(0);

  return (
    <section id="faq-section" className="py-16 lg:py-20 bg-slate-100" data-testid="public-faq-section">
      <div className="max-w-3xl mx-auto px-4 sm:px-6">
        <p className="text-[11px] uppercase tracking-widest text-[#C5A059] font-bold mb-2">Dúvidas</p>
        <h2 className="text-3xl sm:text-4xl font-bold text-[#0A2647] mb-2">{faq.titulo}</h2>
        <p className="text-base text-slate-500 mb-8">{faq.dica}</p>

        <div className="space-y-3">
          {faq.faq.map((item, i) => (
            <div key={i} className="bg-white rounded-xl border border-slate-200 overflow-hidden">
              <button
                onClick={() => setOpen(open === i ? -1 : i)}
                className="w-full flex items-center justify-between gap-4 px-5 py-4 text-left hover:bg-slate-50 transition-colors"
                data-testid={`faq-question-${i}`}
              >
                <span className="font-semibold text-[#0A2647] text-sm sm:text-base">{item.p}</span>
                <ChevronDown className={`w-5 h-5 text-slate-400 flex-shrink-0 transition-transform ${open === i ? 'rotate-180' : ''}`} />
              </button>
              {open === i && (
                <p className="px-5 pb-4 text-slate-600 text-sm leading-relaxed" data-testid={`faq-answer-${i}`}>
                  {item.r}
                </p>
              )}
            </div>
          ))}
        </div>

        <div className="mt-8 text-center">
          <p className="text-sm text-slate-500 mb-3">Ficou com alguma dúvida que não está aqui?</p>
          <a
            href={`https://wa.me/${helpContent.whatsapp}?text=${encodeURIComponent('Olá! Tenho uma dúvida sobre o Falo Com O Dono.')}`}
            target="_blank"
            rel="noopener noreferrer"
            className="inline-flex items-center gap-2 bg-emerald-600 hover:bg-emerald-700 text-white font-bold px-6 py-3 rounded-xl transition-colors"
            data-testid="faq-whatsapp-btn"
          >
            <MessageCircle className="w-4 h-4" />
            {helpContent.whatsapp_label}
          </a>
          <div className="mt-6">
            <Link to="/feira">
              <Button
                size="lg"
                className="relative bg-[#C5A059] hover:bg-[#d4af61] text-[#0A2647] font-bold text-base px-10 h-14 rounded-xl gap-2 transition-all duration-300 hover:shadow-[0_0_40px_rgba(197,160,89,0.45)] active:scale-[0.98]"
                data-testid="faq-cta-btn"
              >
                ⚡ Implantar Agora
                <ArrowRight className="w-5 h-5" />
              </Button>
            </Link>
          </div>
        </div>
      </div>
    </section>
  );
};

export default PublicFaq;
